const messages = {
  en: {
    'Trainer Site': 'Trainer Site',
    'Unit': 'Unit'
  }
}

export default messages
